<template>
  <setting-layout
    header-title="修改密码"
    footer-text="保存"
    @footer-click="submitForm"
    class="reset-password-container"
  >
    <el-form
      ref="form"
      :model="form"
      :rules="rules"
      label-width="120px"
      class="reset-password-form"
    >
      <el-form-item label="账号名">
        <el-input
          :value="user.fullName"
          disabled
        ></el-input>
      </el-form-item>
      <el-form-item
        label="当前密码"
        prop="currentPassword"
      >
        <el-input
          type="password"
          auto-complete="new-password"
          v-model="form.currentPassword"
          placeholder="请输入当前密码"
        ></el-input>
      </el-form-item>
      <el-form-item
        label="新密码"
        prop="newPassword"
      >
        <el-input
          type="password"
          auto-complete="new-password"
          v-model="form.newPassword"
          placeholder="请输入新密码"
          show-password
        ></el-input>
        <p class="password-hint">8到14位字符的密码，包含至少两种字符类型 (字母、数字、标点符号)。</p>
      </el-form-item>
      <el-form-item
        label="新密码确认"
        prop="confirmPassword"
      >
        <el-input
          type="password"
          auto-complete="new-password"
          v-model="form.confirmPassword"
          show-password
          placeholder="请再次输入新密码"
        ></el-input>
      </el-form-item>
    </el-form>
  </setting-layout>
</template>

<script>
import SettingLayout from '@/components/setting-layout.vue';
import { mapGetters } from 'vuex';
import { changePassword } from '@/api/base';
import EventBus from '@/lib/events';

export default {
  name: 'ResetPassword',
  components: {
    SettingLayout,
  },
  computed: {
    ...mapGetters('user', ['user']),
  },
  data() {
    const validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'));
      } else {
        if (this.form.confirmPassword !== '') {
          this.$refs.form.validateField('confirmPassword');
        }
        // Password complexity check: 8-14 chars, at least 2 types (letters, numbers, symbols)
        const regex = /^(?![A-Za-z]+$)(?![A-Z\d]+$)(?![A-Z\W_]+$)(?![a-z\d]+$)(?![a-z\W_]+$)(?![\d\W_]+$)[A-Za-z\d\W_]{8,14}$/;
        if (!regex.test(value)) {
          callback(new Error('8到14位字符的密码，包含至少两种字符类型 (字母、数字、标点符号)'));
        } else {
          callback();
        }
      }
    };
    const validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.form.newPassword) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };
    return {
      form: {
        currentPassword: '',
        newPassword: '',
        confirmPassword: '',
      },
      rules: {
        currentPassword: [{ required: true, message: '请输入当前密码', trigger: 'blur' }],
        newPassword: [{ required: true, validator: validatePass, trigger: 'blur' }],
        confirmPassword: [{ required: true, validator: validatePass2, trigger: 'blur' }],
      },
    };
  },
  methods: {
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          // Replace with actual API call
          changePassword({
            oldPassword: this.form.currentPassword,
            newPassword: this.form.newPassword,
          }).then(() => {
            this.$message.success('密码修改成功，请重新登录!');
            EventBus.$emit('logout');
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
  },
};
</script>

<style lang="scss">
.reset-password-container {
  .reset-password-form {
    max-width: 800px;
    margin: 40px auto 0;
  }

  .password-hint {
    font-size: 12px;
    color: #909399;
    line-height: 1.5;
    margin-top: 5px;
  }

  .el-form-item__label {
    font-weight: bold;
    text-align: left;
  }

  /* Specific adjustment for password hint's asterisk alignment if needed */
  .el-form-item--medium .el-form-item__content {
    position: relative;
  }
}
</style>
